import { TApplicationState } from '../../types/redux';

export function selectLandingType(state: TApplicationState) {
  return state.landingType;
}
